import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import LoginPage from './pages/login';
import BiasDetection from './pages/bias-detection';
import FactChecking from './pages/fact-checking';
import NewsGeneration from './pages/news-generation';
import UserProfile from './pages/user-profile';
import Register from './pages/register';
import ForgotPassword from './pages/forgot-password';
import Checkout from "./pages/checkout";
import PricingModel from "./pages/pricemodel";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";


const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/bias-detection" element={<BiasDetection />} />
        <Route path="/fact-checking" element={<FactChecking />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/news-generation" element={<NewsGeneration />} />
        <Route path="/user-profile" element={<UserProfile />} />
        <Route path="/plans" element={<PricingModel />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
